import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomUpdateProfileComponent } from './custom-update-profile.component';
import { AuthGuard, CmsConfig, ConfigModule, GlobalMessageService, I18nModule, UrlModule } from '@spartacus/core';
import { FormErrorsModule, SpinnerModule } from '@spartacus/storefront';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { EffectsModule } from '@ngrx/effects';
import { CustomDeliveryCountriesEffects } from '../../../../custom/core/user/store/effects/custom-delivery-countries.effect';
import { UserProfileFacade } from '@spartacus/user/profile/root';
import { RouterModule } from '@angular/router';
import { CustomIconsModule } from '../../../../../custom/icons/custom-icons.module';
import { UpdateProfileComponentService } from '@spartacus/user/profile/components';
import { CustomDatePickerModule } from '../../../../../custom/forms/date-picker/custom-date-picker.module';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SpinnerModule,
        I18nModule,
        FormErrorsModule,
        RouterModule,
        UrlModule,
        NgSelectModule,
        CustomDatePickerModule,
        UrlModule,
        CustomIconsModule,
        EffectsModule.forFeature([CustomDeliveryCountriesEffects]),
        ConfigModule.withConfig({
            cmsComponents: {
                UpdateProfileComponent: {
                    component: CustomUpdateProfileComponent,
                    guards: [AuthGuard],
                    providers: [
                        {
                            provide: UpdateProfileComponentService,
                            useClass: UpdateProfileComponentService,
                            deps: [UserProfileFacade, GlobalMessageService],
                        },
                    ],
                },
            },
        } as CmsConfig),
    ],
    declarations: [CustomUpdateProfileComponent],
    exports: [CustomUpdateProfileComponent]
})

export class CustomUpdateProfileModule {
}
